module.exports = __webpack_public_path__ + "static/media/special_symbol.d6e08981.svg";